import React, { MouseEventHandler } from 'react'
import classnames from 'classnames'
import { Mutation } from 'react-apollo'
import FileIcon from '@mui/icons-material/Description'
import css from './IntroductionLink.css'
import { i18n } from '../../../index'
import { fetchFavoriteIntroductionLinks, toggleFavoriteIntroductionLink } from '../../queries'
import { getHttpUrl } from '../../../../common/utils'

function IntroductionLink({ fileName, href, stationId, id, isFavorited, showFavBlock }) {
  return (
    <Mutation
      mutation={toggleFavoriteIntroductionLink}
      refetchQueries={[
        {
          query: fetchFavoriteIntroductionLinks,
          variables: {
            stationId,
          },
        },
      ]}
      variables={{
        stationId,
        id,
      }}
    >
      {(mutate) => (
        <div className={classnames(css.container)}>
          <a href={getHttpUrl(href)} target='_blank' rel='noreferrer'>
            <div className={classnames(css.linkBlock, !showFavBlock && css.roundBorders)}>
              <FileIcon />
              {fileName}
            </div>
          </a>
          {stationId &&
            showFavBlock &&
            (!isFavorited ? (
              <div className={classnames(css.favoriteBlock, css.linkBlock)} onClick={mutate as MouseEventHandler}>
                {i18n.t('introduction.addFavorite')}
              </div>
            ) : (
              <div
                className={classnames(css.favoriteBlock, css.linkBlock, css.removeFavorite)}
                onClick={mutate as MouseEventHandler}
              >
                {i18n.t('introduction.removeFavorite')}
              </div>
            ))}
        </div>
      )}
    </Mutation>
  )
}

export default IntroductionLink
